<a [href]="generateHrefLink()">
  <div class="search-item-container">
    <i class="fs-16px" *ngIf="!showAvatar" [uiType]="icon" [uiTooltipTitle]="icon" ui-icon uiTheme="fill" ui-tooltip></i>
    <ui-assignee-avatar *ngIf="showAvatar" [fromAssigneeId]="item.id" uiSize="xs"></ui-assignee-avatar>
    <div class="details">
      <div class="name">{{ item.fields["title"] || item.fields["fullName"] || item.fields["name"] }}</div>
      <ui-assignee-name *ngIf="item.collectionName === 'users'" [uiAssignee]="getAssignee()"></ui-assignee-name>
    </div>
    <!--<div class="last-visited" ng-if="isRecent">-->
    <!--  <div>{{ item.fields.lastVisited }}</div>-->
    <!--</div>-->
  </div>
  <ng-container class="avatars" *ngIf="getAssigneeIds(item.collectionName) as assigneeIds">
    <ui-assignee-avatar-group [uiAlignRight]="true" uiSize="xs">
      <ui-assignee-avatar *ngFor="let aId of assigneeIds" [fromAssigneeId]="aId" />
    </ui-assignee-avatar-group>
  </ng-container>
</a>
